<template>
    <div v-loading="dataLoading">
        <el-form
            v-if="data && formData"
            :model="formData"
            ref="formData"
            label-position="top"
        >
            <div class="group">
                <div class="page-group-title"><span>基本信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单ID: </span>{{data.id}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单编号: </span>{{data.sn}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付状态: </span>{{data.paymentStatus == 1  ? '未支付' : '已支付'}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单状态: </span>{{orderStatus.get(data.orderStatus)}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单终端: </span>{{data.terminal}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">联系手机: </span>{{data.areaCode ? '+'+data.areaCode.split('_')[0] : ''}} {{data.telephone}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单时间: </span>{{data.createTime}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单备注: </span>{{data.customerRemark}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>众筹信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col>{{data.goodName}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">众筹ID: </span>{{data.goodId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">发起人身份: </span>{{data.promoterUserType}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">发起人: </span>{{data.promoterName}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>支持人信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户ID: </span>{{data.supporterId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户名: </span>{{data.supporter}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">账号手机: </span>{{data.supporterUserPhone}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">身份: </span>{{data.supporterUserType}}</el-col>
                    </el-row>
                 </el-card>
            </div>

            <div v-if="data.deliveryTypesCode != 9" class="group MT20">
                <div class="page-group-title"><span>收货信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <template v-if="data.deliveryTypesCode == 8">
                            <el-col :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="customerName" label="收货人姓名:" :rules="[{required: true, message: '请输入收货人姓名'}]">
                                    <el-input v-model.trim="formData.customerName" placeholder="请输入收货人姓名" maxlength="20" size="medium"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="telephone" label="联系手机:" :rules="[{required: true, message: '请输入联系手机'}]">
                                    <el-input class="input-with-select" v-model.trim="formData.telephone" placeholder="请输入联系手机" maxlength="20" size="medium">
                                        <el-select v-model="formData.areaCode" slot="prepend" placeholder="请选择区号">
                                            <el-option v-for="(item,index) in countryList" :key="index" :label="`+${item.code}`" :value="item.codeView">
                                                +{{item.code}} {{item.name}}
                                            </el-option>
                                        </el-select>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="city" label="收货省市:" :rules="[{required: true, message: '请选择收货省份城市'}]">
                                    <el-cascader
                                        v-model="formData.city"
                                        :options="cityList"
                                        filterable
                                        :props="{label:'name',children:'cityList',value:'name'}"
                                        size="medium"
                                        style="width:100%"
                                        ref="cityCascader"
                                        @change="changeCity">
                                    </el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="address" label="收货地址:" :rules="[{required: true, message: '请输入收货地址'}]">
                                    <el-input v-model.trim="formData.address" placeholder="请输入收货地址" maxlength="100" size="medium"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="formData.expressId" :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="expressId" label="快递公司:" :rules="[{required: true, message: '请输入快递公司'}]">
                                    <el-select v-model="formData.expressId" size="medium" placeholder="请选择快递公司">
                                        <el-option v-for="(item,index) in expressList" :key="index" :value="item.expressId" :label="item.expressName"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="formData.expressNo" :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="expressNo" label="运单号:" :rules="[{required: true, message: '请输入运单号'}]">
                                    <el-input v-model.trim="formData.expressNo" placeholder="请输入运单号" maxlength="40" size="medium"></el-input>
                                </el-form-item>
                            </el-col>
                        </template>
                        <el-col v-if="data.deliveryTypesCode == 7" :xs="24" :sm="12" :xl="8">
                            <el-form-item prop="address" label="收货人邮箱:" :rules="[{required: true, message: '请输入收货邮箱'},{ type: 'email', message: '请输入正确的邮箱地址'}]">
                                <el-input v-model.trim="formData.address" placeholder="请输入收货邮箱" maxlength="100" size="medium"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

            <div class="group MT20">
                <div class="page-group-title"><span>回报项信息</span></div>
                <div class="MT20">
                    <el-card v-for="(item,index) in data.orderDetailVO2s" :key="index" shadow="never" class="MT10">
                        <el-row :gutter="40">
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">名称: </span>{{item.skuName}}</el-col>
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支持份数: </span>{{item.num}}</el-col>
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">发货方式: </span>{{item.deliveryType}}</el-col>
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">预计回报时间: </span>{{item.redoundTime}}</el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>支付信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付渠道: </span>{{data.payPlatformName}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付平台交易号: </span>{{data.outTradeNo}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支持总数: </span>{{data.payNum}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单总价: </span>{{data.totalAmountStr}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单应付: </span>{{data.payableAmountStr}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">实际支付: </span>{{data.realPayAmountStr || 0}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付时间: </span>{{data.payTime}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>订单备注</span></div>
                <div class="MT20">
                    <el-form-item prop="systemRemark">
                        <el-input v-model="formData.systemRemark" type="textarea" :rows="4" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="group MT20">
                <el-button @click="goBack">返回</el-button>
                <el-button
                    v-if="$utils.have('/activiOrder/save')"
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >保存</el-button
                >
                <el-button
                    v-if="!data.expressName && !data.expressNo && data.orderStatus != 6 && data.deliveryTypesCode !=9 && $utils.have('/raise/order/deliverGoods')"
                    @click="$refs.updateDeliverInfo.show(data)"
                    type="warning"
                    >发货</el-button>
                <el-button
                    v-if="(data.orderStatus == 2 || data.orderStatus == 4 || data.orderStatus == 3 || data.orderStatus == 5) && $utils.have('/raise/order/cancel') && data.canCancelOrder"
                    type="danger"
                    @click="cancel(data.id)"
                    >取消</el-button>    
            </div>
        </el-form>
        <UpdateDeliverInfo ref="updateDeliverInfo" @onUpdate="goBack"></UpdateDeliverInfo>
    </div>
</template>

<script>
import {fetchExpress,fetchAllCity,fetchAllCountry} from '@/assets/js/commonApi';
import UpdateDeliverInfo from './components/updateDeliverInfo';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{UpdateDeliverInfo},
    data(){
        return{
            dataLoading: false,
            redirect: this.$route.query.redirect || '/raise/order/list',
            data:null,
            formData:null,
            btnLoading: false,
            expressList:[],//所有快递
            cityList:[],//所有省份城市集合
            countryList:[],//所有国家集合
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
				[7,'已取消'],
            ])
        },
    },
    created(){
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods:{
         //获取快递公司
        getExpressList(){
            fetchExpress().then((res) => {
                const {state,result} = res.data;
                if(state == 1){
                    this.expressList = result;
                }
            }).catch(() => {})
        },
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        //获取所有国家（区号）
        async getCountryList(){
            const res = await fetchAllCountry({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.countryList = result;
            }
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/raise/order/detail",
                params: { orderId: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = {...result};
                        this.formData = {
                            customerName: result.customerName || '',
                            areaCode:result.areaCode || '86_CN',
                            telephone: result.telephone || '',
                            address: result.address || '',
                            expressId:result.expressId || '',
                            expressNo:result.expressNo || '',
                            provinceName: result.provinceName || '北京',
                            cityName: result.cityName || '北京',
                            orderId: result.id,
                            city: [result.provinceName || '北京',result.cityName || '北京'],
                            systemRemark: result.systemRemark || '',
                        }
                        if(result.deliveryTypesCode == 8){
                            this.getExpressList();
                            this.getCityList();
                            this.getCountryList();
                        }
                    } else {
                        this.$message.error(msg || "获取订单详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取订单详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //选择城市
        changeCity(value){
            this.formData.provinceName = value ? value[0] : '';
            this.formData.cityName = value ? value[1] : '';
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/raise/order/save",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //取消订单
        cancel(id){
            this.$confirm('确定要取消吗?', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.dataLoading = true;
                this.$request({
                    url: '/raise/order/cancel',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.goBack();
                    }else{
                        this.$message.error(msg || '操作失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.dataLoading = false;
                });
            }).catch(() => {});
        },
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
    }
}
</style>